import { render, staticRenderFns } from "./tab-icons.vue?vue&type=template&id=5413aeff&scoped=true"
import script from "./tab-icons.vue?vue&type=script&lang=js"
export * from "./tab-icons.vue?vue&type=script&lang=js"
import style0 from "./tab-icons.vue?vue&type=style&index=0&id=5413aeff&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5413aeff",
  null
  
)

export default component.exports